import { useEffect } from 'react';

import { useQuery } from './use-query';

interface UseFetchByQueryIdParams<T> {
  queryName?: string;
  selectDetails: (data?: T) => void;
  trigger: (id: string) => Promise<{ data?: T }>;
}

export const useFetchByQueryId = <T,>({
  trigger,
  selectDetails,
  queryName = 'id',
}: UseFetchByQueryIdParams<T>) => {
  const [queryId, setQueryId] = useQuery(queryName, '', true);

  useEffect(() => {
    if (!queryId) {
      selectDetails(undefined);
      return;
    }

    const getDetails = async () => {
      const { data } = await trigger(queryId);
      selectDetails(data ?? undefined);
    };

    getDetails();
  }, [queryId]);

  return { queryId, setQueryId };
};
